import React from "react";
import { Control, UseFormSetValue, get } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { purchaserInvoiceForm, recipientInvoiceForm } from "./inputsForm/InputPayFormModels";
import { FormElementModel } from "../../models/FormElementModel";
import EATextField from "../shared/TextField/EATextField";
import EANipInput from "../shared/NipInput/EANipInput";
import { InputsFinalize } from "./FinalizeNoLogin";

interface IProps {
  register: any;
  errors: any;
  control: Control<InputsFinalize>;
  setValue: UseFormSetValue<InputsFinalize>;
  countryCodes: string[];
  countryCodesError: boolean;
}

const RecipientAndPurchaserForm: React.FC<IProps> = ({
  register,
  errors,
  control,
  setValue,
  countryCodes,
  countryCodesError,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <h3>{t("dane_do_faktury")}</h3>
      <h5 className="text-color-dark-gray" style={{ marginBottom: "16px" }}>
        {t("odbiorca")}
      </h5>
      <div className={"inputs-customer-invoice"}>
        {recipientInvoiceForm(register).map((item: FormElementModel, index: number) => (
          <React.Fragment key={index}>
            {item.name ? (
              <EATextField
                label={item.text}
                name={item.name}
                type={item.type as "text" | "email" | "password" | "number"}
                placeholder={item.placeholder}
                register={item.register}
                error={!!get(errors, item.name)}
                helperText={get(errors, item.name)?.message}
                fullWidth
              />
            ) : null}
            {item.name === "recipient.name" && (
              <EANipInput
                control={control}
                name="recipient.vatId"
                countryCodeFieldName="recipient.countryCode"
                setValue={setValue}
                errors={errors}
                label={t("nip")}
                countries={countryCodes}
                showCountrySelect={!countryCodesError}
                fullWidth
              />
            )}
          </React.Fragment>
        ))}
      </div>
      <h5 className="text-color-dark-gray" style={{ marginBottom: "16px", marginTop: "32px" }}>
        {t("nabywca")}
      </h5>
      <div className={"inputs-customer-invoice"}>
        {purchaserInvoiceForm(register).map((item: FormElementModel, index: number) => (
          <React.Fragment key={index}>
            {item.name ? (
              <EATextField
                label={item.text}
                name={item.name}
                type={item.type as "text" | "email" | "password" | "number"}
                placeholder={item.placeholder}
                register={item.register}
                error={!!get(errors, item.name)}
                helperText={get(errors, item.name)?.message}
                fullWidth
              />
            ) : null}
            {item.name === "purchaser.name" && (
              <EANipInput
                control={control}
                name="purchaser.vatId"
                countryCodeFieldName="purchaser.countryCode"
                setValue={setValue}
                errors={errors}
                label={t("nip")}
                countries={countryCodes}
                showCountrySelect={!countryCodesError}
                fullWidth
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </>
  );
};

export default RecipientAndPurchaserForm;
